import { ResponseArray, ResponseObject } from '@/types/shared'
import qs from 'query-string'
import {
    OperationExpense,
    CreateOperationExpenseRequest,
    BatchCreateOperationExpensesRequest,
    UpdateOperationExpenseRequest,
    OperationExpenseListParams,
    OperationExpenseSummary,
    CategorySummary,
    SummaryParams,
    CategorySummaryParams,
} from '../types'
import datacentral from '@/utils/axios/datacentral'

const BASE_URL = '/reports/bi/operation-expenses'

// 1. List Operation Expenses
export const listOperationExpenses = async (
    params?: OperationExpenseListParams
): Promise<OperationExpense[]> => {
    const queryString = qs.stringify(params || {}, { arrayFormat: 'bracket' })
    const { data } = await datacentral.get<ResponseArray<OperationExpense>>(
        `${BASE_URL}?${queryString}`
    )
    return data?.results || []
}

// 2. Get Operation Expense Detail
export const getOperationExpenseDetail = async (
    id: number
): Promise<OperationExpense> => {
    const { data } = await datacentral.get<ResponseObject<OperationExpense>>(
        `${BASE_URL}/${id}`
    )
    return data?.result as OperationExpense
}

// 3. Create Operation Expense
export const createOperationExpense = async (
    requestData: CreateOperationExpenseRequest
): Promise<OperationExpense> => {
    const { data } = await datacentral.post<ResponseObject<OperationExpense>>(
        BASE_URL,
        requestData
    )
    return data?.result as OperationExpense
}

// 4. Batch Create Operation Expenses
export const batchCreateOperationExpenses = async (
    requestData: BatchCreateOperationExpensesRequest
): Promise<OperationExpense[]> => {
    const response = await datacentral.post<ResponseArray<OperationExpense>>(
        `${BASE_URL}/batch`,
        requestData
    )
    return response.data?.results || []
}

// 5. Update Operation Expense
export const updateOperationExpense = async (
    id: number,
    requestData: UpdateOperationExpenseRequest
): Promise<OperationExpense> => {
    const { data } = await datacentral.put<ResponseObject<OperationExpense>>(
        `${BASE_URL}/${id}`,
        requestData
    )
    return data?.result as OperationExpense
}

// 6. Delete Operation Expense (Soft Delete)
export const deleteOperationExpense = async (id: number): Promise<void> => {
    await datacentral.delete(`${BASE_URL}/${id}`)
}

// 7. Get Monthly Summary
export const getMonthlySummary = async (
    params?: SummaryParams
): Promise<OperationExpenseSummary[]> => {
    const queryString = qs.stringify(params || {}, { arrayFormat: 'bracket' })
    const { data } = await datacentral.get<
        ResponseArray<OperationExpenseSummary>
    >(`${BASE_URL}/monthly-summary?${queryString}`)
    return data?.results || []
}

// 8. Get Category Summary
export const getCategorySummary = async (
    params?: CategorySummaryParams
): Promise<CategorySummary[]> => {
    const queryString = qs.stringify(params || {}, { arrayFormat: 'bracket' })
    const { data } = await datacentral.get<ResponseArray<CategorySummary>>(
        `${BASE_URL}/category-summary?${queryString}`
    )
    return data?.results || []
}

// 9. Bulk Delete Operation Expenses
export const bulkDeleteOperationExpenses = async (
    ids: number[]
): Promise<void> => {
    await datacentral.post(`${BASE_URL}/bulk-delete`, { ids })
}

// 10. Restore Deleted Operation Expense
export const restoreOperationExpense = async (id: number): Promise<void> => {
    await datacentral.post(`${BASE_URL}/${id}/restore`)
}
